import classes from "./LogoutBtn.module.css"

function LogoutBtn(props) {
  const { onClick } = props;

  return <button onClick={onClick} className={classes.logoutBtn}>Logout</button>;
}

export default LogoutBtn;
